const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const log = require('../../util/log');
const formatMessage = require('format-message');
const Cast = require('../../util/cast');
const util = require('../../engine/block-utility');
const StringUtil = require('../../util/string-util');
const FileSaver = require('file-saver');

/**
 * Icon svg to be displayed at the left edge of each extension block, encoded as a data URI.
 * @type {string}
 */
const blockIconURI = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMjguNi4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogMS4yLjAgQnVpbGQgNzA5KSAgLS0+CiAgPGc+CiAgICA8ZyBpZD0iX+ODrOOCpOODpOODvF8xIiBkYXRhLW5hbWU9IuODrOOCpOODpOODvF8xIj4KICAgICAgPGcgaWQ9Il/jg6zjgqTjg6Tjg7xfMS0yIiBkYXRhLW5hbWU9Il/jg6zjgqTjg6Tjg7xfMSI+CiAgICAgICAgPGcgaWQ9Il94MzJfIj4KICAgICAgICAgIDxnPgogICAgICAgICAgICA8cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjUiIHk9IjYiIHdpZHRoPSI1LjYiIGhlaWdodD0iNS42Ii8+CiAgICAgICAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iMTQuNCIgeT0iNiIgd2lkdGg9IjIwLjYiIGhlaWdodD0iNS42Ii8+CiAgICAgICAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iNSIgeT0iMTcuMiIgd2lkdGg9IjUuNiIgaGVpZ2h0PSI1LjYiLz4KICAgICAgICAgICAgPHJlY3QgY2xhc3M9ImNscy0xIiB4PSIxNC40IiB5PSIxNy4yIiB3aWR0aD0iMjAuNiIgaGVpZ2h0PSI1LjYiLz4KICAgICAgICAgICAgPHJlY3QgY2xhc3M9ImNscy0xIiB4PSI1IiB5PSIyOC41IiB3aWR0aD0iNS42IiBoZWlnaHQ9IjUuNiIvPgogICAgICAgICAgICA8cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjE0LjQiIHk9IjI4LjUiIHdpZHRoPSIyMC42IiBoZWlnaHQ9IjUuNiIvPgogICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+'
const menuIconURI = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjNGM0YzRjOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMjguNi4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogMS4yLjAgQnVpbGQgNzA5KSAgLS0+CiAgPGc+CiAgICA8ZyBpZD0iX+ODrOOCpOODpOODvF8xIiBkYXRhLW5hbWU9IuODrOOCpOODpOODvF8xIj4KICAgICAgPGcgaWQ9Il/jg6zjgqTjg6Tjg7xfMS0yIiBkYXRhLW5hbWU9Il/jg6zjgqTjg6Tjg7xfMSI+CiAgICAgICAgPGcgaWQ9Il/jg6zjgqTjg6Tjg7xfMS0yIj4KICAgICAgICAgIDxnIGlkPSJfeDMyXyI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iNSIgeT0iNiIgd2lkdGg9IjUuNiIgaGVpZ2h0PSI1LjYiLz4KICAgICAgICAgICAgICA8cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjE0LjQiIHk9IjYiIHdpZHRoPSIyMC42IiBoZWlnaHQ9IjUuNiIvPgogICAgICAgICAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iNSIgeT0iMTcuMiIgd2lkdGg9IjUuNiIgaGVpZ2h0PSI1LjYiLz4KICAgICAgICAgICAgICA8cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjE0LjQiIHk9IjE3LjIiIHdpZHRoPSIyMC42IiBoZWlnaHQ9IjUuNiIvPgogICAgICAgICAgICAgIDxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iNSIgeT0iMjguNSIgd2lkdGg9IjUuNiIgaGVpZ2h0PSI1LjYiLz4KICAgICAgICAgICAgICA8cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjE0LjQiIHk9IjI4LjUiIHdpZHRoPSIyMC42IiBoZWlnaHQ9IjUuNiIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4='

class list2CSV {
    constructor (runtime) {
        this.runtime = runtime;
        this.logData = []
    }

    getInfo () {
        return {
            id: 'list2CSV',
            name: 'list2CSV',
            blockIconURI: blockIconURI,
            menuIconURI: menuIconURI,
            blocks: [
                {
                    opcode: 'logList',
                    blockType: BlockType.REPORTER,
                    text: 'データログ用リスト',
                },
                {
                    opcode: 'appendList',
                    blockType: BlockType.COMMAND,
                    text: 'データログ用リストにリスト[LIST]を追加',
                    arguments: {
                        LIST: {
                            type: ArgumentType.STRING,
                            defaultValue: ' '
                        }
                    }
                },
                {
                    opcode: 'appendName',
                    blockType: BlockType.COMMAND,
                    text: '[INDEX]番目のリスト名を[NAME]にする',
                    arguments:{
                        INDEX: {
                            type: ArgumentType.NUMBER,
                            defaultValue: '1',
                        },
                        NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'リスト1'
                        }
                    }
                },
                {
                    opcode: 'deleteLogList',
                    blockType: BlockType.COMMAND,
                    text: 'データ用ログリストのすべてを削除する'
                },
                {
                    opcode: 'exportList',
                    blockType: BlockType.COMMAND,
                    text: 'リスト [LIST]をCSVでダウンロードする',
                    arguments: {
                        LIST: {
                            type: ArgumentType.STRING,
                            defaultValue: ' '
                        }
                    }
                },
            ]
        }
    }

    toJSON (optTargetId) {
        const sb3 = require('../../serialization/sb3');
        return StringUtil.stringify(sb3.serialize(this.runtime, optTargetId));
    }
    getList(listName) {
        const jsons = this.toJSON()
        const jsonObj = JSON.parse(jsons);
        let lists;
        let CSVValue = [listName];
        if ('targets' in jsonObj) {
            lists = jsonObj['targets'][0]['lists'];
        }
        for (let listID in lists) {
            let name = lists[listID][0];
            CSVValue.push(lists[listID][1]);
            if (name === listName){
                if (CSVValue.length == 0){
                    alert("リストの中身が空です")
                    return false
                }else{
                    return CSVValue
                }
            }
        }
    }
    getListName(blockName){
        const jsons = this.toJSON()
        const jsonObj = JSON.parse(jsons);
        let blocks;
        if ('targets' in jsonObj) {
            blocks = jsonObj['targets'][1]['blocks']; // 配置されている全てのブロックの一覧．
        }
        for (let blockID in blocks) {
            if (blocks[blockID]['opcode'] === blockName){
                let listIndex = blocks[blockID]['inputs']['LIST'][1]
                if (!Array.isArray(listIndex)){
                    if (listIndex in blocks){
                        console.log("Return loglist name")
                        return 'list2CSV_logList'
                    }
                    else{
                        alert("リストブロックを入れいてください")
                        return
                    }
                }else{
                    let listName = listIndex[1]
                    if (!listName || listName == 'undefined'){
                        return false
                    }else{
                        return listName
                    }
                }
            }
        }

    }
    arrayToCSV(data) {
        if (!Array.isArray(data)) return false
        // 2次元配列であればマップして返す
        if (data.every(element => Array.isArray(element))) {
            return data.map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
        }else{
            return data
        }
    }

    exportList(args){
        let listValue = []
        let listName = this.getListName('list2CSV_exportList')
        // console.log(listName)
        if (!listName){
            alert("ブロックが入っていません")
            return
        }
        if (listName === "list2CSV_logList") {
            listValue = this.logData
            listName = "logging_data"
        }
        else{
            listValue = this.getList(listName)
        }
        if (listValue){
            // console.log(listValue)
            const csv = this.arrayToCSV(listValue)
            const bom = new Uint8Array([0xef, 0xbb, 0xbf]) //ここでUTF-8を指定
            let blob = new Blob([bom, csv], {type: "text/csv"});
            FileSaver.saveAs(blob, `${listName}.csv`)
        }


    }
    logList(){
        return this.arrayToCSV(this.logData);
    }
    deleteLogList(){
        this.logData = []
    }
    appendList(args){
        // let listName = this.getListName('list2CSV_appendList')
        // let val = this.getList(listName)
        // this.logData = this.logData.concat([val])
        let listVal = args.LIST
        // let tmpList = [listName]
        let tmpList = []
        if(!listVal.includes(' ')){
            let _tmp = listVal.split('')
            tmpList = tmpList.concat(_tmp)
            this.logData.push(tmpList)
        }else{
            // tmpList = tmpList + ' ' + listVal
            tmpList = listVal
            tmpList = tmpList.split(' ')
            this.logData.push(tmpList)
        }
    }
    appendName(args){
        let index = args.INDEX
        let name = args.NAME
        // console.log("this log data")
        // console.log(this.logData[index-1])
        try{
            this.logData[index-1].unshift(name)
        }catch{
            console.error("Cannot append list name")
        }
    }
}
module.exports = list2CSV;
